module.exports = __webpack_public_path__ + "static/img/home_header_top.133e6197.png";